import { AppConfig } from '@/utils/AppConfig';

import { useTranslation } from 'react-i18next';
import { PercentegeChart } from './Charts/PercentegeChart';
import { FinancialSummary } from '@/types/globalTypes';
import { formatMoney } from '@/utils/helpers';


type PercentageData = {
    success: boolean;
    sales: number;
    onlineSales: number;
    cashSales: number;
    onlineRatio: number; // 0 to 1
    cashRatio: number;   // 0 to 1
};
interface Props {
    data: FinancialSummary;
    percentageData: PercentageData
}

export default function FinancialReport({ data, percentageData }: Props) {
    const { t } = useTranslation();  // Destructure translation functions


    // Define the financial items with translation keys
    const items: { label: string; value: string; type: "cost" | "income" }[] = [
        { label: 'menuSales.online', value: data.total, type: "income" },
        { label: 'cashierSales', value: data.cashierTotal, type: "income" },
        { label: 'totalCash', value: data.cashTotal, type: "income" },
        { label: 'totalOnline', value: data.onlineTotal, type: "income" },
        { label: 'returns', value: data.cashierReturnedTotal, type: "cost" },
        { label: 'costs.products', value: data.costs, type: "cost" },
        { label: 'couponsDiscount.value', value: data.couponDiscount, type: "cost" },
        { label: 'taxes.amount', value: data.taxesAmount, type: "cost" },
        { label: 'paymentFees.online', value: data.onlinePaymentFees, type: "cost" },
        { label: 'totalAmount', value: data.gross, type: "income" },
        { label: 'netProfit', value: data.netProfit, type: "income" },

    ];


    return (
        <>
            <div className="w-full  grid grid-cols-1 xl:grid-cols-2 gap-4  shadow-lg bg-white rounded-lg  mx-auto">
                <div className="bg-white p-6 rounded-lg md:max-w-[80%] xl:max-w-full mx-auto w-full">
                    <h2 className="text-xl font-semibold text-center text-gray-800 mb-10">
                        {t("financialReport.title")}
                    </h2>

                    <div className="space-y-3">
                        {items.map((item, index) => {
                            const isCost = item.type === "cost";
                            const valueClass = isCost ? "text-red-600" : "text-green-600";
                            const prefix = isCost ? " − " : " + ";

                            return (
                                <div
                                    key={index}
                                    className="flex justify-between items-center px-4 py-3 bg-gray-50 rounded-md hover:bg-gray-100 transition duration-200"
                                >
                                    <span className="text-gray-700 text-sm sm:text-base font-medium truncate max-w-[60%]">
                                        {t(item.label)}
                                    </span>

                                    <div className="flex items-center gap-2 whitespace-nowrap text-sm sm:text-base">
                                        <span className={`font-semibold flex items-center gap-2 ${valueClass}`}>
                                            {prefix}{formatMoney(item.value)}
                                            <span>{AppConfig.currency.icon()}</span>
                                        </span>
                                    </div>
                                </div>
                            );
                        })}

                    </div>
                </div>



                <PercentegeChart data={percentageData} />
            </div>



        </>


    );
}
